import {AChartX} from "@atiautomacao/ati-ui-library";
import React, {FunctionComponent, useEffect, useState} from "react";
import {useTheme} from "@mui/material";
import {useAppSelector} from "../../../../Config/Hooks";
import DataNotFound from "../../../../Shared/Components/DataNotFoundMessage";
import {UserCommandCount} from "../reactQuery/CommandCountByOperatorReactQuery";

interface Props {
    data: UserCommandCount[] | undefined;
    height?: number;
}

const BAR_COLOR = "#071AC8";
const VISIBLE_BARS = 15;



const CommandsByOperatorBarChart: FunctionComponent<Props> = ({data, height = 300}) => {
    const openSubMenu = useAppSelector((state: any) => state.layout.openSubMenu);
    const theme = useTheme();

    const sortedData = React.useMemo(() => {
        if (!data || data.length === 0) return [];
        return [...data].sort((a, b) => b.count - a.count);
    }, [data]);

    // @ts-ignore
    const option: AChartXProps['option'] = React.useMemo(() => {
        const total = sortedData.length;
        const showDataZoom = total > VISIBLE_BARS;

        return {
            toolbox: {show: false},
            tooltip: {
                trigger: 'axis',
                axisPointer: {type: 'shadow'},
                formatter: (params: any) => {
                    const item = Array.isArray(params) ? params[0] : params;
                    return `${item.name}<br/>Comandos: <b>${item.value}</b>`;
                }
            },
            grid: {
                containLabel: true,
                top: 10,
                bottom: 24,
                left: 8,
                right: showDataZoom ? 28 : 16,
            },
            xAxis: {
                type: 'value',
                minInterval: 1,
                splitLine: {lineStyle: {type: 'dashed', color: '#e0e0e0'}},
                axisLine: {show: false},
                axisTick: {show: false},
            },
            yAxis: {
                type: 'category',
                inverse: true, // maior quantidade no topo
                data: sortedData.map(item => item.name),
                axisTick: {show: false},
                axisLabel: {
                    formatter: (value: string) =>
                        value && value.length > 16 ? value.substring(0, 16) + '…' : value,
                }
            },
            dataZoom: showDataZoom ? [
                {type: 'slider', yAxisIndex: 0, startValue: 0, endValue: VISIBLE_BARS - 1, width: 12, right: 6},
                {type: 'inside', yAxisIndex: 0, startValue: 0, endValue: VISIBLE_BARS - 1}
            ] : [],
            series: [{
                name: 'Comandos',
                type: 'bar',
                data: sortedData.map(item => item.count),
                barMaxWidth: 16,
                itemStyle: {color: BAR_COLOR, borderRadius: [0, 4, 4, 0]}
            }]
        };
    }, [sortedData]);

    const [content, setContent] = useState<JSX.Element>();
    useEffect(() => {
        if (sortedData.length > 0) {
            setContent(
                <AChartX
                    key={`commands-by-operator-chart-${openSubMenu}`}
                    option={option}
                    width={'100%'}
                    height={height}
                    loading={false}
                    theme={theme.palette.mode}
                />
            );
        } else {
            setContent(<DataNotFound boxStyle={{height, width: '100%'}}/>);
        }
    }, [sortedData, openSubMenu, option, height, theme.palette.mode]);

    return <>{content}</>;
};

export default CommandsByOperatorBarChart;
